<template>
  <div class="one">
    <leftImg style="flex:1" :more-url="['/main?type=1&selected=4&page=1','/main?type=1&selected=6&page=1']" :param="[{top:18,type:3},{ top: 18, type: 4 }]" :text="['政策法规','党建动态']" />
    <news style="margin-left:40px" more-url="/main?type=1&selected=6&page=1" :param="{ top: 9, type: 13 }" :text="['会议纪要']" />
  </div>
</template>

<script>
import news from '../oneCol.vue'
import leftImg from '../leftImg.vue'
export default {
  components: {
    news, leftImg
  },
  data() {
    return {
      dataList: []
    }
  },
  watch: {
  },
  created() {
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .el-carousel__arrow{
    border-radius: unset!important;
    background-color: rgba(0,0,0,0)!important;
  }
  .el-carousel__arrow--right,.el-carousel__arrow--left{
    margin-top: 203px;
  }
  .el-icon-arrow-right:before,.el-icon-arrow-left:before{
    font-size:20px;
    font-weight: 800;
  }
}
.one{
  display: flex;
  background:#fff;
  .lunbo{
    height: 100%;
    position: relative;
    &>div{
      position: absolute;
      bottom: 0;
      left: 0;
      right:0;
      height: 60px;
      background: rgba(0,0,0,.5);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-around;
      &>div:last-child{
        width: 70%;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;

      }
      .page{
          &>span:first-child{
            font-size: 23px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            opacity: .8;
          }
          &>span:last-child{
            font-size:20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            opacity: .8;
          }
        }
    }
    img{
      width: 100%;
      height: 100%;
    }
  }
}

</style>
